export default __webpack_public_path__ + "static/insfocus_cover-big_1-6dd0724b5fe446ccdc1149ceb9c1a255.png";